module.exports = __webpack_public_path__ + "img/ico-contact-company_3.a2a91be9.svg";